import { globalLogger } from '../../../../helper/global-logger.js';
import * as helper from './helper';
import { createSatApi } from '../../../../../lib-sat/api/api.js';

/**
 * @type {null|Api}
 */
var api = null;
var _deferred = null;

function postInput(postData) {
    var deferred = $.Deferred();

    api.ajaxWrapper
        .post(postData)
        .done(function () {
            globalLogger.info('image editor - add final input done');
            deferred.resolve();
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            globalLogger.error('image editor - add final input fail - post input fail');
            deferred.reject(jqXHR);
        });

    return deferred;
}

function addInputWithRetries(jobId, postData) {
    _deferred = $.Deferred();

    api = createSatApi({});

    addInput(jobId, postData, 0);

    return _deferred;
}

function addInput(jobId, postData, retries) {
    if (retries > 5) {
        globalLogger.error('image editor - add final input fail - too many retries');
        _deferred.reject();

        return;
    }

    function handleFail(response) {
        if (response.status >= 400 && response.status < 500) {
            globalLogger.error('image editor - add final input fail - 400 server response', response);
            _deferred.reject();

            return;
        }

        setTimeout(function () {
            api.getJobInfo(jobId)
                .done(function (jobInfo) {
                    if (jobInfo.input.length === 1) {
                        globalLogger.info('image editor - add final input done - after getjobinfo');
                        _deferred.resolve();

                        return;
                    }

                    if (jobInfo.input.length > 1) {
                        globalLogger.error('image editor - add final input fail - multiple inputs added');
                        _deferred.reject();

                        return;
                    }

                    globalLogger.error('image editor - add final input fail - no input added');
                    addInput(jobId, postData, ++retries);
                })
                .fail(function () {
                    globalLogger.error('image editor - add final input fail - getjobinfo fail');
                    _deferred.reject();
                });
        }, 3000);
    }

    postInput(postData)
        .done(function () {
            _deferred.resolve();
        })
        .fail(handleFail);
}

export { addInputWithRetries };
